var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.127 2c-1.137 0-2.064.898-2.064 2v4C3.923 8 3 8.895 3 10v5c0 1.105.923 2 2.063 2v3c0 1.102.927 2 2.064 2h12.38c1.137 0 2.064-.898 2.064-2V4c0-1.102-.927-2-2.063-2H7.127zm0 2h12.38v6c0-1.105-.922-2-2.063-2H7.127V4zm-.29 6.031c1.531 0 1.7 1.168 1.74 1.719h-1.03c0-.406-.025-.906-.71-.906-.27 0-.774-.031-.774 1.25v.844c0 .925.185 1.25.742 1.25.588 0 .741-.356.741-.876h1.032C8.554 13.867 8.332 15 6.805 15 5.05 15 5.03 13.273 5.03 12.937v-.843c0-.848.323-2.063 1.806-2.063zm4.224 0c1.503 0 1.58 1.281 1.58 1.5h-1.032c0-.101-.033-.719-.58-.719-.549 0-.581.485-.581.563-.004.844 2.192.625 2.192 2.281 0 .215-.064 1.344-1.58 1.344-1.656 0-1.74-1.32-1.74-1.594h1.031c0 .145-.072.813.71.813.096 0 .548-.051.548-.563 0-1.07-2.16-.625-2.16-2.281 0-.2.169-1.344 1.612-1.344zm2.289.063h1.128l.838 3.5.871-3.5h1.128l-1.45 4.844H14.8l-1.451-4.844zM19.508 15v5H7.127v-3h10.317c1.141 0 2.064-.895 2.064-2z",
    id: "export-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#export-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.aef3a9846e2e60aca11785a98b57b7a2.svg";
export { ForwardRef as ReactComponent };